import { useEffect } from 'react';
import SitePage from 'components/Site/Page';
import { useTranslation } from 'next-i18next';
import { initializeStore } from 'lib/store';
import ArticleFullView from 'views/Articles/Full';
import isNaN from 'lodash/isNaN';
import API from 'api';
import { useProductEvents } from 'hooks';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';

const ArticlePage = (props) => {
  const { t } = useTranslation('common');
  const { article, moreArticles } = props;
  const events = useProductEvents();

  useEffect(() => {
    events.send('article_open_workshop', { title: article.title })
  }, [])

  return (
    <SitePage
      {...props}
      title={article.title}
      keywords={article.keywords}
      ogURL={`http://client.zencar.tech/articles/${article.slug}`}
      isLanding={true}
    >
      <ArticleFullView
        article={article}
        moreArticles={moreArticles}
      />
    </SitePage>
  )
};

export async function getServerSideProps({ locale, query }) {
  const { slug } = query;
  const store = initializeStore();
  const { dispatch } = store;
  const isId = !isNaN(Number(slug));
  const filterField = isId ? 'id' : 'slug';

  const article = await dispatch(API.queries.article({
    where: { [filterField]: { eq: isId ? +slug : slug } }
  }));

  const articleData = article.data.article;

  const moreArticles = await dispatch(API.queries.articles({
    where: {
      articleCategory: { id: { eq: articleData.articleCategoryId } }
    },
    paginate: { page: 1, limit: 8 }
  }));

  return {
    props: {
      ...await serverSideTranslations(locale, ['common', 'landing', 'header']),
      article: articleData,
      moreArticles: moreArticles.data.articles.items || []
    }
  }
}

export default ArticlePage;